<template>
    <v-text-field
        outlined
        dense
        :hide-details="hideDetails"
        :error="errorBorder"
        :error-messages="error"
        :hint="$props.hint"
        :label="$props.label"
        :mask="$props.mask"
        :placeholder="$props.placeholder"
        :readonly="$props.readonly"
        :disabled="$props.disabled"
        :type="$props.type"
        v-model="inputValue"
    ></v-text-field>
</template>

<script>
export default {
    name: 'InputField',
    props: {
        readonly: Boolean,
        disabled: Boolean,
        value: [String, Number],
        errorBorder: {
            type: Boolean,
            default: false,
        },
        error: {
            type: String,
            default: '',
        },
        placeholder: String,
        label: String,
        type: String,
        mask: String,
        hint: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            inputValue: this.$props.value,
        };
    },
    computed: {
        hideDetails() {
            return this.$props.error === '' && this.$props.hint === '';
        },
    },
    watch: {
        inputValue() {
            this.$emit('input', this.inputValue);
        },
        value() {
            this.inputValue = this.$props.value;
        },
    },
};
</script>

<style scoped></style>
